/* HFB-056-AB */
(function () {
  var tries = 0;
  var maxTries = 24;
  var debounceTimer = null;
  var loadInFlight = false;

  function sectionVisible() {
    var root = document.querySelector(".hfb-056-intimacy-cards");
    if (!root) return false;
    var sec = root.closest(".shopify-section");
    if (!sec) return false;
    return window.getComputedStyle(sec).display !== "none";
  }

  var mqMobileSlider = window.matchMedia
    ? window.matchMedia("(max-width: 1279.98px)")
    : null;

  function isMobileForSlider() {
    if (mqMobileSlider) return mqMobileSlider.matches;
    return window.innerWidth < 1280;
  }

  function clearSwiperLayoutArtifacts() {
    var track = document.querySelector(
      ".hfb-056-intimacy-cards__track.swiper-wrapper"
    );
    if (track) {
      track.removeAttribute("style");
    }
    document
      .querySelectorAll(
        ".hfb-056-intimacy-cards__swiper .hfb-056-intimacy-cards__card.swiper-slide"
      )
      .forEach(function (slide) {
        slide.removeAttribute("style");
      });
  }

  function loadRealSwiperThen(cb) {
    if (typeof window.loadSwiper === "function" && window.swiperBundleUrl) {
      window.loadSwiper(cb);
      return;
    }
    if (typeof window.Swiper !== "undefined" && !window.Swiper._isStub) {
      window.setTimeout(function () {
        cb();
      }, 0);
      return;
    }
    if (window.swiperBundleUrl) {
      var sc = document.createElement("script");
      sc.src = window.swiperBundleUrl;
      sc.onload = cb;
      sc.onerror = function () {
        cb();
      };
      (document.body || document.documentElement).appendChild(sc);
      return;
    }
    window.setTimeout(function () {
      cb();
    }, 0);
  }

  function destroyIfAny(el) {
    if (el && el.swiper) {
      try {
        el.swiper.destroy(true, true);
      } catch (e) {}
    }
    clearSwiperLayoutArtifacts();
  }

  function buildSwiper() {
    if (!sectionVisible() || !isMobileForSlider()) {
      return;
    }

    var el = document.querySelector(".hfb-056-intimacy-cards__swiper");
    if (!el) return;
    if (el.swiper) return;

    var pagination = el.querySelector(".hfb-056-intimacy-cards__pagination");
    if (!pagination) return;
    if (loadInFlight) return;

    loadInFlight = true;
    loadRealSwiperThen(function () {
      loadInFlight = false;
      if (!sectionVisible() || !isMobileForSlider()) return;
      if (typeof window.Swiper === "undefined" || window.Swiper._isStub) return;
      if (!el.isConnected) return;
      if (el.swiper) return;

      new window.Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 12,
        watchOverflow: true,
        centeredSlides: false,
        roundLengths: true,
        observer: true,
        observeParents: true,
        pagination: {
          el: pagination,
          clickable: true
        },
        breakpoints: {
          480: {
            slidesPerView: 1.05,
            spaceBetween: 14
          },
          600: {
            slidesPerView: 1.2,
            spaceBetween: 16
          },
          750: {
            slidesPerView: 1.5,
            spaceBetween: 20
          },
          1024: {
            slidesPerView: 2,
            spaceBetween: 24
          }
        }
      });
      if (el.swiper) {
        requestAnimationFrame(function () {
          if (el.swiper) el.swiper.update();
        });
      }
    });
  }

  function handleLayout() {
    if (!isMobileForSlider()) {
      var el = document.querySelector(".hfb-056-intimacy-cards__swiper");
      destroyIfAny(el);
    } else {
      tries = 0;
      retryBuild();
    }
  }

  function retryBuild() {
    var el = document.querySelector(".hfb-056-intimacy-cards__swiper");
    if (el && el.swiper) return;
    buildSwiper();
    tries += 1;
    if (tries < maxTries) {
      window.setTimeout(retryBuild, 200);
    }
  }

  function onResize() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      var el = document.querySelector(".hfb-056-intimacy-cards__swiper");
      if (el && el.swiper && isMobileForSlider()) {
        try {
          el.swiper.update();
        } catch (e) {}
      }
      handleLayout();
    }, 150);
  }

  function watchForVisibility(target) {
    if (!target) return;
    new MutationObserver(function () {
      if (sectionVisible()) {
        tries = 0;
        retryBuild();
      }
    }).observe(target, { attributes: true, attributeFilter: ["class", "style"] });
  }

  document.addEventListener("DOMContentLoaded", function () {
    handleLayout();
    tries = 0;
    retryBuild();
  });
  window.addEventListener("load", function () {
    handleLayout();
    tries = 0;
    retryBuild();
  });
  window.addEventListener("resize", onResize, { passive: true });
  if (mqMobileSlider) {
    var mql = mqMobileSlider;
    if (mql.addEventListener) {
      mql.addEventListener("change", function () {
        handleLayout();
      });
    } else if (mql.addListener) {
      mql.addListener(function () {
        handleLayout();
      });
    }
  }
  document.addEventListener("swiper:loaded", function () {
    tries = 0;
    retryBuild();
  });

  watchForVisibility(document.documentElement);
  if (document.body) {
    watchForVisibility(document.body);
  } else {
    document.addEventListener("DOMContentLoaded", function () {
      watchForVisibility(document.body);
    });
  }
})();
